const POINT_ACTION = 'pa';
const COUPON_PROVIDER = 'cp';
const SHOP = 'sh';
const STAMP_CARD = 'sc';
const RAFFLE = 'rf';

module.exports = {
  POINT_ACTION,
  COUPON_PROVIDER,
  SHOP,
  STAMP_CARD,
  RAFFLE,

  /**
   * PointActionモデルを示すスキーム文字列を返す
   * @param {string} id
   * @param {string} token
   * @returns {string}
   */
  pointAction(id, token) {
    return `cs:${POINT_ACTION}/${id}/${token}`;
  },

  /**
   * CouponProviderモデルを示すスキーム文字列を返す
   * @param {string} id
   * @param {string} token
   * @returns {string}
   */
  couponProvider(id, token) {
    return `cs:${COUPON_PROVIDER}/${id}/${token}`;
  },

  /**
   * Shopモデルを示すスキーム文字列を返す
   * @param {string} id
   * @returns {string}
   */
  shop(id) {
    return `cs:${SHOP}/${id}`;
  },

  /**
   * StampCardモデルを示すスキーム文字列を返す
   * @param {string} id
   * @returns {string}
   */
  stampCard(id) {
    return `cs:${STAMP_CARD}/${id}`;
  },

  /**
   * StampCardモデルのスタンプ項目を示すスキーム文字列を返す
   * @param {string} id
   * @param {string} [itemKey]
   * @returns {string}
   */
  stampCardItem(id, itemKey = undefined) {
    return `cs:${STAMP_CARD}/${id}/${itemKey || ''}`;
  },

  /**
   * Raffleモデルを示すスキーム文字列を返す
   * @param {string} id
   * @returns {string}
   */
  raffle(id) {
    return `cs:${RAFFLE}/${id}`;
  },

  /**
   * COMSBI SaaS スキーム文字列を展開する
   * @param {string} value
   * @returns {[string]}
   */
  parse(value) {
    if (value.indexOf('cs:') !== 0) throw new Error(`invalid scheme. value:${value}`);
    const [uri, queryStr = ''] = value.split('?');
    return [...uri.split('cs:')[1].split('/')];
  },
};
